import React, { useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AuthContext } from '../context/AuthContext';
import { TarotContext } from '../context/TarotContext';
import '../styles/DashboardPage.css';

const DashboardPage = () => {
  const { user, logout } = useContext(AuthContext);
  const { fetchRemainingReadings, remainingReadings } = useContext(TarotContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    
    fetchRemainingReadings();
  }, [user, navigate, fetchRemainingReadings]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  if (!user) return null;

  return (
    <div className="dashboard-container">
      <motion.div 
        className="dashboard-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h1>Portal Místico</h1>
        
        <div className="user-info">
          <div className="user-avatar">
            <span>{user.name.charAt(0)}</span>
          </div>
          <div className="user-details">
            <h2>Bienvenido, {user.name}</h2>
            <p>{user.email}</p>
          </div>
        </div>
        
        <div className="readings-info-card">
          <h3>Tus Lecturas</h3>
          <div className="readings-count">
            <span className="count">{remainingReadings}</span>
            <span className="label">lecturas disponibles hoy</span>
          </div>
          
          {remainingReadings > 0 ? (
            <Link to="/reading" className="main-button">
              Realizar Consulta
            </Link>
          ) : (
            <div className="no-readings-message">
              <p>Has agotado tus lecturas diarias</p>
              <p className="small">Vuelve mañana para más consultas</p>
            </div>
          )}
        </div>
        
        <button onClick={handleLogout} className="logout-button">
          Cerrar Sesión
        </button>
      </motion.div>
    </div>
  );
};

export default DashboardPage; 